import Hero from "./Hero.vue";
export default Hero;
